<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">
      <!-- Brand logo-->
      <b-link class="brand-logo">
        <vuexy-logo />
        <h2 class="brand-text text-primary ml-1 custom-text">APTF Smiljanić</h2>
      </b-link>
      <!-- /Brand logo-->

      <!-- Login-->
      <b-col
        lg="4"
        class="d-flex align-items-center auth-bg px-2 p-lg-5 m-auto"
        style="display: block !important"
      >
        <b-col sm="8" md="6" lg="12" class="px-xl-2 mx-auto">
          <div
            style="margin-bottom: 50px"
            class="d-flex align-items-center flex-wrap"
          >
            <b-img fluid src="/slika1.jpg" alt="Login V2" class="slika1" />
            <b-img fluid src="/slika3.png" alt="Login V2" class="w-100" />
          </div>
          <b-card-title title-tag="h2" class="font-weight-bold mb-1">
            Prijavite se na svoj nalog
          </b-card-title>
          <!-- <b-card-text class="mb-2">
            Prijavite se na svoj nalog i započnite avanturu
          </b-card-text> -->

          <!-- form -->
          <validation-observer ref="loginValidation">
            <b-form class="auth-login-form mt-2" @submit.prevent>
              <!-- email -->
              <b-form-group label="Korisničko ime" label-for="login-email">
                <validation-provider
                  #default="{ errors }"
                  name="Email"
                  rules="required"
                >
                  <b-form-input
                    id="login-email"
                    v-model="userEmail"
                    :state="errors.length > 0 ? false : null"
                    name="login-email"
                    placeholder="john@example.com"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- forgot password -->
              <b-form-group>
                <div class="d-flex justify-content-between">
                  <label for="login-password">Lozinka</label>
                  <!-- :to="{ name: 'auth-forgot-password-v2' }" -->
                  <!-- <b-link>
                    <small>Zaboravili ste lozinku?</small>
                  </b-link> -->
                </div>
                <validation-provider
                  #default="{ errors }"
                  name="Password"
                  rules="required"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid' : null"
                  >
                    <b-form-input
                      id="login-password"
                      v-model="password"
                      :state="errors.length > 0 ? false : null"
                      class="form-control-merge"
                      :type="passwordFieldType"
                      name="login-password"
                      placeholder="············"
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        class="cursor-pointer"
                        :icon="passwordToggleIcon"
                        @click="togglePasswordVisibility"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <!-- ERROR MESSAGE -->
              <b-form-group>
                <b-alert
                  v-model="wrongCredentialsFlag"
                  v-height-fade.appear
                  variant="danger"
                  dismissible
                  class="mb-0"
                >
                  <div class="alert-body">
                    Korisničko ime ili lozinka nisu ispravni!
                  </div>
                </b-alert>
              </b-form-group>
              <!-- checkbox -->
              <!-- <b-form-group>
                <b-form-checkbox
                  id="remember-me"
                  v-model="status"
                  name="checkbox-1"
                >
                  Zapamti me
                </b-form-checkbox>
              </b-form-group> -->

              <!-- submit buttons -->
              <b-button
                type="submit"
                variant="primary"
                block
                @click="validationForm"
              >
                Prijavite se
              </b-button>
            </b-form>
          </validation-observer>

          <!-- <b-card-text class="text-center mt-2">
            <span>Novi ste na našj platformi? </span>
            <b-link>
              <span>&nbsp;Napravite nalog</span>
            </b-link>
          </b-card-text>

          <div class="divider my-2">
            <div class="divider-text">
              ili
            </div>
          </div>

          <div class="auth-footer-btn d-flex justify-content-center">
            <b-button variant="facebook" href="javascript:void(0)">
              <feather-icon icon="FacebookIcon" />
            </b-button>
            <b-button variant="twitter" href="javascript:void(0)">
              <feather-icon icon="TwitterIcon" />
            </b-button>
            <b-button variant="google" href="javascript:void(0)">
              <feather-icon icon="MailIcon" />
            </b-button>
            <b-button variant="github" href="javascript:void(0)">
              <feather-icon icon="GithubIcon" />
            </b-button>
          </div> -->
        </b-col>
      </b-col>
      <!-- /Login-->
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { BAlert } from "bootstrap-vue";
import { heightFade } from "@core/directives/animations";
import Ripple from "vue-ripple-directive";
import VuexyLogo from "@core/layouts/components/Logo.vue";
import {
  BRow,
  BCol,
  BLink,
  BFormGroup,
  BFormInput,
  BInputGroupAppend,
  BInputGroup,
  BFormCheckbox,
  BCardText,
  BCardTitle,
  BImg,
  BForm,
  BButton,
} from "bootstrap-vue";
import { required, email } from "@validations";
import { togglePasswordVisibility } from "@core/mixins/ui/forms";
import store from "@/store/index";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  components: {
    BAlert,
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BFormCheckbox,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    VuexyLogo,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    "height-fade": heightFade,
    Ripple,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      status: "",
      password: "",
      userEmail: "",
      wrongCredentialsFlag: false,
      clickedLogin: false,
      sideImg: require("@/assets/images/pages/login-v2.svg"),
      // validation rulesimport store from '@/store/index'
      required,
      email,
    };
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === "password" ? "EyeIcon" : "EyeOffIcon";
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === "dark") {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require("@/assets/images/pages/login-v2-dark.svg");
        return this.sideImg;
      }
      return this.sideImg;
    },
  },
  beforeCreate() {
    if (localStorage.getItem("user")) {
      this.$router.push("/").catch(() => {});
    }
  },
  created() {
    console.log(this.$swal);
  },
  methods: {
    validationForm() {
      var $this = this;
      // this.$store.commit("loader/SHOW_LOADER");
      this.$refs.loginValidation.validate().then((success) => {
        if (success) {
          store
            .dispatch("login/LOGIN", {
              username: this.userEmail,
              password: this.password,
            })
            .then((response) => {
              $this.$store.commit("loader/HIDE_LOADER");
              store.commit(
                "login/SET_TOKEN",
                "Bearer " + response.data.jwtToken
              );
              store.commit(
                "login/SET_REFRESH_TOKEN",
                response.data.refreshToken
              );
              store.commit("login/SET_USER", JSON.stringify(response.data));
              store.commit("loader/HIDE_LOADER");
              $this.wrongCredentialsFlag = false;
              // this.$toast(
              //   {
              //     component: ToastificationContent,
              //     props: {
              //       title: "Uspješno ste se prijavili ",
              //       icon: "CheckIcon",
              //       variant: "success",
              //     },
              //   },
              //   {
              //     position: "top-center",
              //   }
              // );
              // bottom end
              this.$swal({
                position: "bottom-end",
                icon: "success",
                title: "Uspješno ste se prijavili",
                showConfirmButton: false,
                timer: 1500,
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                buttonsStyling: false,
              });
              window.location.href = "/smiljanic/home";
            })
            .catch((error) => {
              $this.clickedLogin = false;
              if (error && error.status == 400)
                $this.wrongCredentialsFlag = true;
              $this.$store.commit("loader/HIDE_LOADER");
            });
        } else {
          $this.$store.commit("loader/HIDE_LOADER");
        }
      });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-auth.scss";
.custom-text {
  font-size: 2.4rem;
}
.slika-logo {
  width: 90%;
  opacity: 0.9;
  border-radius: 10px;
}
.footer {
  text-align: center;
  width: 100%;
  position: absolute;
  bottom: 10px;
  color: black;
  font-size: 13px;
}
.image-panel {
  background: white;
}
.slika1 {
  z-index: 2;
  margin: auto;
  width: 40%;
  display: block;
}
.slika2 {
  z-index: 2;
  margin: auto;
  width: 35%;
  display: block;
}
</style>
